import { useAsyncQuery } from "#imports";
import { GET_ALTADENA_DISCLAIMER } from "~/graphql/GetAltadenaDisclaimer";

/**
 * Altadena licensing disclaimer, edited in WP under Site Options > Altadena.
 * Falls back to the hardcoded ALTADENA_DISCLAIMER if the field is empty or
 * the query fails, so the disclaimer never renders blank.
 */
export async function useAltadenaDisclaimer() {
  const { data } = await useAsyncQuery({
    query: GET_ALTADENA_DISCLAIMER,
    key: "altadena-disclaimer",
  });

  return computed(() => data?.value?.altadenaDisclaimer || ALTADENA_DISCLAIMER);
}
